export default __webpack_public_path__ + "static/media/zucchero5.769fda85.webp";